import { Badge } from '@fluentui/react-components';
import { useT } from '../../i18n';

/** Estado de los datos clave (KDE) de un registro: completo o lista de faltantes. */
export function KdeStatusBadge({ missing }: { missing: string[] }) {
  const t = useT();
  const labels = t.traceability.kdeFields as Record<string, string>;
  if (missing.length === 0) {
    return <Badge data-testid="kde-badge" appearance="tint" color="success">{t.traceability.kdeComplete}</Badge>;
  }
  return (
    <Badge data-testid="kde-badge" appearance="tint" color="warning">
      {t.traceability.kdeMissingPrefix}: {missing.map(m => labels[m] ?? m).join(', ')}
    </Badge>
  );
}
